var extras = document.querySelectorAll('[data-action="add-extra"]');
async function addExtra(e) {
  extras.forEach((b) => {
    b.setAttribute("disabled", "disabled");
    b.setAttribute("aria-busy", "true");
  });
  document.documentElement.dispatchEvent(
    new CustomEvent("theme:loading:start", { bubbles: true })
  );
  let id = e.target.id;
  const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
    body: JSON.stringify({ quantity: 1, id: id }),
    credentials: "same-origin",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
    },
  });
  extras.forEach((b) => {
    b.removeAttribute("disabled");
    b.removeAttribute("aria-busy");
  });
  document.documentElement.dispatchEvent(
    new CustomEvent("theme:loading:end", { bubbles: true })
  );
  if (response.ok) {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      })
    );
    const drawer = document.getElementById("cart-drawer");
    drawer.show();
  }
}
for (let ex of extras) {
  ex.addEventListener("click", addExtra);
}
